'use client';
import { useMediaQuery } from 'react-responsive';

type UseDeviceProps = {
  isDesktop: boolean;
  isLaptop: boolean;
  isTablet: boolean;
  isMobile: boolean;
  isSmallDevice: boolean;
};

export const useDevice = (): UseDeviceProps => {
  const isDesktop = useMediaQuery({ minWidth: 1400 });
  const isLaptop = useMediaQuery({ maxWidth: 1280 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });
  const isMobile = useMediaQuery({ maxWidth: 769 });

  const isSmallDevice = isLaptop || isTablet || isMobile;

  return { isDesktop, isLaptop, isTablet, isMobile, isSmallDevice };
};
